module.exports = __webpack_public_path__ + "static/media/waterdrops.61a46ff5.png";